/* CREATE! Hero: Einblenden beim Laden/Scrollen. Ohne dieses Skript ist der Banner trotzdem vollständig sichtbar. */
(function () {
  'use strict';
  function los() {
    var liste = document.querySelectorAll('.ca-hero .ca-reveal, .ca-hinweis .ca-reveal');
    var reduziert = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduziert || !('IntersectionObserver' in window)) { liste.forEach(function (e) { e.classList.add('ca-in'); }); return; }
    var io = new IntersectionObserver(function (x) {
      x.forEach(function (t) { if (t.isIntersecting) { t.target.classList.add('ca-in'); io.unobserve(t.target); } });
    }, { threshold: 0.05 });
    liste.forEach(function (e) { io.observe(e); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los); else los();
  /* Theme-Editor: wird die Section neu gerendert (z. B. Folie eingeblendet), sind die neuen Texte sonst unsichtbar */
  document.addEventListener('shopify:section:load', los);
  document.addEventListener('shopify:block:select', los);
})();

/* Newsletter: Emoji aus dem Klaviyo-Text entfernen (Klaviyo rendert nach dem Laden). */
(function () {
  'use strict';
  var EMOJI = /[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}]/gu;
  function putzen() {
    var f = document.querySelector('.klaviyo-form-TQTJZg');
    if (!f) return;
    var w = document.createTreeWalker(f, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      if (EMOJI.test(n.nodeValue)) { EMOJI.lastIndex = 0; n.nodeValue = n.nodeValue.replace(EMOJI, '').replace(/\s+$/, ''); }
      EMOJI.lastIndex = 0;
    }
  }
  function los() {
    putzen();
    var f = document.querySelector('.klaviyo-form-TQTJZg') || document.body;
    new MutationObserver(putzen).observe(f, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los); else los();
})();

/* Glas-Varianten zum Ansehen: Standard = weißer Lichtschein hinter den Kacheln; ?glas=r (Rauchglas-Rahmen um die Kacheln), ?glas=b (Rauchglas-Kasten), ?glas=d (Eis und Rot), ?glas=w (hell), ?glas=n (wie Standard). Wird pro Tab gemerkt. */
(function () {
  'use strict';
  try {
    var m = location.search.match(/[?&]glas=([bdwnr])/);
    if (m) sessionStorage.setItem('ctGlas', m[1]);
    var v = sessionStorage.getItem('ctGlas');
    if (v === 'b') document.body.classList.add('ct-glas-b');
    if (v === 'r') document.body.classList.add('ct-glas-r');
    if (v === 'd') document.body.classList.add('ct-glas-d');
    if (v === 'w') document.body.classList.add('ct-glas-w');
    if (v === 'n') document.body.classList.add('ct-glas-n');
  } catch (e) {}
})();

/* Menü (mobil): Newsletter-Kachel oben einsetzen */
(function () {
  'use strict';
  function los() {
    var d = document.getElementById('NavDrawer');
    if (!d || d.querySelector('.ct-menu-news')) return;
    var ziel = d.querySelector('.drawer__scrollable');
    if (!ziel) return;
    var a = document.createElement('a');
    a.className = 'ct-menu-news';
    a.href = '/pages/newsletter';
    a.innerHTML = '<span class="ct-menu-news__text"><span class="ct-menu-news__k">Geschenk</span><span class="ct-menu-news__h">2 Federzwingen gratis zum Newsletter</span><span class="ct-menu-news__b">Jetzt sichern</span></span>' +
      '<span class="ct-menu-news__i" style="background-image:url(https://cdn.shopify.com/s/files/1/0944/3177/3013/files/cClamp_Federzwingen-HQ2erset.jpg?width=480&height=360&crop=center)"></span>';
    ziel.insertBefore(a, ziel.firstChild);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los); else los();
})();

/* Varianten-Bilder (Swatch-App): unbeschnittenes Bild laden, damit das ganze Produkt sichtbar ist */
(function () {
  'use strict';
  function fix(root) {
    (root || document).querySelectorAll('.swatch-image .star-set-image[style*="crop="]').forEach(function (el) {
      el.style.backgroundImage = el.style.backgroundImage.replace(/&(amp;)?height=\d+/g, '').replace(/&(amp;)?crop=\w+/g, '').replace(/width=\d+/, 'width=360');
    });
  }
  function los() {
    fix();
    var t = 0, mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(fix, 50); });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los); else los();
})();

/* Produktkacheln: Titel pro Reihe gleich hoch, damit die Bewertungen auf einer Linie stehen */
(function () {
  'use strict';
  function angleichen() {
    var namen = document.querySelectorAll('.armano-products .armano-products__name');
    namen.forEach(function (n) { n.style.removeProperty('min-height'); });
    var reihen = {};
    namen.forEach(function (n) {
      var item = n.closest('.armano-products__item');
      if (!item || !item.offsetParent) return;
      var grid = item.parentElement;
      var key = (grid.dataset.ctGrid || (grid.dataset.ctGrid = Math.random().toString(36).slice(2))) + ':' + Math.round(item.getBoundingClientRect().top + window.scrollY);
      (reihen[key] = reihen[key] || []).push(n);
    });
    Object.keys(reihen).forEach(function (k) {
      var r = reihen[k];
      if (r.length < 2) return;
      var max = 0;
      r.forEach(function (n) { max = Math.max(max, n.getBoundingClientRect().height); });
      r.forEach(function (n) { n.style.setProperty('min-height', Math.ceil(max) + 'px', 'important'); });
    });
  }
  var t = 0;
  function spaeter() { clearTimeout(t); t = setTimeout(angleichen, 120); }
  function los() {
    angleichen();
    window.addEventListener('resize', spaeter);
    window.addEventListener('load', spaeter);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(spaeter);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los); else los();
})();
